
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/sites/editors/home-page/live-preview",
      function () {
        return require("private-next-pages/admin/sites/editors/home-page/live-preview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/sites/editors/home-page/live-preview"])
      });
    }
  